/*
  Caramel — evita que el listener global de "clic fuera del carrito lo
  cierra" (definido en assets/theme.js, Drawers.prototype.close) se
  dispare por clics en widgets de terceros insertados fuera de la propia
  página (por ejemplo el aviso/pestaña de código de descuento de Klaviyo,
  con su propio botón de cerrar "X" — pero esto protege igual frente a
  cualquier otro widget externo, presente o futuro).

  HISTORIAL:
  - v1 (fase de captura sobre document): cortaba el clic antes de que
    llegara al propio botón de Klaviyo -> ni el aviso ni el carrito se
    cerraban.
  - v2 (fase de burbuja sobre document, deteniendo la propagación hacia
    window): en teoría debía dejar pasar el clic al botón de Klaviyo y
    solo bloquear el listener del tema -- pero el carrito se seguía
    cerrando. Sin poder inspeccionar el DOM real de Klaviyo en vivo (usa
    su propio script en tiempo de ejecución, con estructura interna que no
    controlamos -- posible shadow DOM, clases sin "klaviyo" literal, etc.),
    intentar adivinar un selector para "esto es de Klaviyo" es frágil.

  v3 (este archivo) -- enfoque distinto, sin adivinar nada de Klaviyo:
  en vez de intentar reconocer qué es Klaviyo, reconocemos qué es
  DEFINITIVAMENTE parte de la propia tienda: todo el contenido real del
  tema vive dentro de #PageContainer (confirmado en layout/theme.liquid;
  #CartDrawer se renderiza desde sections/header.liquid, que forma parte
  de 'header-group', dentro de #PageContainer). Cualquier script de
  terceros (Klaviyo, banners de cookies, chats, etc.) que inserte su UI
  añadiéndola a <body> queda automáticamente FUERA de #PageContainer.

  Por eso, en vez de interceptar el evento de clic, parcheamos
  directamente Drawers.prototype.close: además de sus comprobaciones
  originales (no cerrar si el clic es el botón .js-drawer-close, no
  cerrar si el clic fue dentro de .drawer), añadimos una tercera: si el
  clic NO fue dentro de #PageContainer tampoco, no lo tratamos como "clic
  fuera del carrito" y no cerramos. Cualquier clic real dentro de la
  página (header, fondo oscuro, etc.) sigue cerrando el carrito como
  siempre; el cierre por Escape (que llama a close() sin evento) tampoco
  se ve afectado.

  2026-07-22
*/
(function () {
  function patchDrawerClose() {
    if (
      !window.theme ||
      !theme.Drawers ||
      !theme.Drawers.prototype ||
      theme.Drawers.prototype.__caramelPatched
    ) {
      return false;
    }

    var originalClose = theme.Drawers.prototype.close;

    theme.Drawers.prototype.close = function (evt) {
      if (evt && evt.target && evt.target.closest) {
        var isCloseButton = evt.target.closest('.js-drawer-close');
        var isInsideDrawer = evt.target.closest('.drawer');
        var isInsideRealPage = evt.target.closest('#PageContainer');

        if (!isCloseButton && !isInsideDrawer && !isInsideRealPage) {
          // El clic no vino del botón de cerrar, no fue dentro del
          // drawer, y tampoco fue dentro del contenido real de la
          // página -> es un widget externo (Klaviyo u otro). No lo
          // tratamos como "clic fuera del carrito".
          return;
        }
      }

      return originalClose.apply(this, arguments);
    };

    theme.Drawers.prototype.__caramelPatched = true;
    return true;
  }

  // theme.js se carga con defer justo antes que este script, así que en
  // condiciones normales ya está listo. El fallback cubre cualquier caso
  // de carga fuera de lo habitual.
  if (!patchDrawerClose()) {
    document.addEventListener('DOMContentLoaded', patchDrawerClose);
  }
})();
